export default function () {
  return {
    storeUrl: '',
    storeInfo: {},
    categoryData: {},
    productData: {},
    cartDetailData: {},
    storeSEO: '{}',
    // improve scroll Categories
    categories: [],
  };
}
